import { FilterTabsContext } from "./FilterTabsContext";

export function FilterTabsProvider({
  children,
  open,
  setOpen,
}: {
  children: React.ReactNode;
  open: boolean;
  setOpen: (value: boolean) => void;
}) {
  return (
    <FilterTabsContext.Provider
      value={{
        open,
        setOpen,
      }}
    >
      {children}
    </FilterTabsContext.Provider>
  );
}
